export * from './lib/MFEProvider';
export { default } from './lib/MFEProvider';
